module.exports = __webpack_public_path__ + "static/zy-2cd37058bdef1d045edf78a421770b2a.png";